import React from 'react';
import { useState } from 'react';
import Socials from './Components/socialMediaBar.js';
import { usePageSwipe } from './Hooks/UsePageSwipe';
import { usePageEnter } from './Hooks/UsePageEnter';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';

import { Highlight1 } from './App';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Frame,
  Toolbar,
  Window,
    Avatar,
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';


const HomePage = () =>{
    usePageEnter();

    console.log(Highlight1)
    const { transitionTo } = usePageSwipe(Highlight1, null);// swipe up → AboutPage

    const [open, setOpen] = useState(false);

    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
    
    return(
               <ThemeProvider theme={rose}>
                   <div style={{height: "100%", display: "flex", flexDirection:"row", width: '100%', justifyContent: "space-around"}}>
                        
                        <div style={{ display: "flex", flexDirection:"column", width: '10%', justifyContent: "space-around",  zIndex: 10}}>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/ContactPage')}>Contact Me</Button>
                       </div>
                        <div style={{ display: "flex", flex: .25, flexDirection:"column", width: '10%', justifyContent: "space-around", position: 'relative'}}>
                            <Avatar size='100' src='./images/me.png' />
                            <Window resizable className='window' style={{ display: 'block', width: 'calc(20vh * (3/2))', maxWidth: "400px", alignSelf: 'center', top: '-40px'}}>
                                <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>Hey there</span>
                                </WindowHeader>

                                <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
                                <Frame variant='well' className='footer' style={{ height: '100%', width: '100%', margin: 0 }}>
                                    <div style={{ padding: '1rem', }}>
                                        <h3 style={{ fontSize: 'clamp(8px, 4vw, 24px)', textAlign: 'center' }}>Xara Neale Shaw is...</h3>
                                        <ul style={{ color: "#c43961", fontSize: 'clamp(8px, 3vw, 18px)', textAlign: 'center', listStylePosition: 'inside', padding: 0, margin: 0}}>
                                            <li>A game designer </li>
                                            <li>A web designer  </li>
                                            <li>A writer  </li>
                                        </ul>
                                        
                                    </div>
                                </Frame>
                                </WindowContent>
                            </Window>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/AboutPage')}>About Xara</Button>
                        </div>
                       <div style={{display: "flex", flexDirection:"column", width: '10%', justifyContent: "space-around"}}>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/Resume')}>My Resume and Credits</Button>
                       </div>
               
                   </div>
               </ThemeProvider>
           );
}

export default HomePage;
